import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "../src/assets/css/style.css";
import "../src/assets/css/responsive.css";
import "../src/assets/css/bootstrap.css";
import AnalystLogin from "./components/AnalystLogin";
import Otpverification from "./components/Otpverification";
import ConfirmYourIdentity from "./components/ConfirmYourIdentity";
import OtpVerificationNumber from "./components/OtpVerificationNumber";
import WelcomeJosh from "./components/WelcomeJosh";
import WelcomePersonalInfo from "./components/WelcomePersonalInfo";
import BankDetails from "./components/BankDetails";
import AlmostThere from "./components/AlmostThere";
import AreYouSure from "./components/AreYouSure";
import DownloadSample from "./components/DownloadSample";
import DownloadSampleEvo from "./components/DownloadSampleEvo";
import UploadPracticeVideos from "./components/UploadPracticeVideos";
import UploadNewPracticeVideo from "./components/UploadNewPracticeVideo";
import BackHome from "./components/BackHome";
import YouApplicationIsApproved from "./components/YouApplicationIsApproved";
import Available from "./components/Available";
import Completed from "./components/Completed";
import AnalystApplication from "./components/AnalystApplication";
import AnalystApplicantJohnDoe from "./components/AnalystApplicantJohnDoe";
import Work from "./components/Work";
import UploadYourWorkHere from "./components/UploadYourWorkHere";
import AreYouSureUpload from "./components/AreYouSureUpload";
import EditProfile from "./components/EditProfile";
import AccountSettings from "./components/AccountSettings";
import EditSettings from "./components/EditSettings";
import Wallet from "./components/Wallet";
import Logout from "./components/Logout";
import Video from "./components/Video";
import SignUpScreen from "./components/SignUpScreen";
import ProtectedRoutes from "./components/ProtectedRoute";
import Redirect from "./components/Redirect";
import ApplicantProfile from "./components/ApplicantProfile";
import OtpLogs from "./components/OtpLogs";
import LogsVideo from "./components/LogsVideo";
import ForgetPassword from "./components/ForgetPassword";
import VerifyYourEmail from "./components/VerifyYourEmail";
import Resetpassword from "./components/ResetPassword";
import UserVerificationByEmailPhone from "./components/UserVerificationByEmailPhone";
import UpdateUserInfo from "./components/UpdateUserInfo";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          exact
          path="/"
          element={
            <Redirect>
              <AnalystLogin />
            </Redirect>
          }
        />
        <Route
          path="/otpverification"
          element={
            <Redirect>
              <Otpverification />
            </Redirect>
          }
        />
        <Route
          path="/email-phone-verification"
          element={
            <Redirect>
              <UserVerificationByEmailPhone />
            </Redirect>
          }
        />
        <Route
          path="/edit-info"
          element={
            <Redirect>
              <UpdateUserInfo />
            </Redirect>
          }
        />
        <Route
          path="/confirmYourIdentity"
          element={
            <ProtectedRoutes>
              <ConfirmYourIdentity />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/otpVerificationNumber"
          element={
            <ProtectedRoutes>
              <OtpVerificationNumber />
            </ProtectedRoutes>
          }
        />

        <Route
          path="/welcomeJosh"
          element={
            <ProtectedRoutes>
              <WelcomeJosh />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/welcomePersonalInfo"
          element={
            <ProtectedRoutes>
              <WelcomePersonalInfo />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/bankDetails"
          element={
            <ProtectedRoutes>
              <BankDetails />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/almostThere"
          element={
            <ProtectedRoutes>
              <AlmostThere />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/areYouSure"
          element={
            <ProtectedRoutes>
              <AreYouSure />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/downloadSample"
          element={
            <ProtectedRoutes>
              <DownloadSample />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/downloadSampleEvo"
          element={
            <ProtectedRoutes>
              <DownloadSampleEvo />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/ploadPracticeVideos"
          element={
            <ProtectedRoutes>
              <UploadPracticeVideos />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/uploadNewPracticeVideo"
          element={
            <ProtectedRoutes>
              <UploadNewPracticeVideo />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/backHome"
          element={
            <ProtectedRoutes>
              <BackHome />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/youApplicationIsApproved"
          element={
            <ProtectedRoutes>
              <YouApplicationIsApproved />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/available"
          element={
            <ProtectedRoutes>
              <Available />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/completed"
          element={
            <ProtectedRoutes>
              <Completed />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/analystApplication"
          element={
            <ProtectedRoutes>
              <AnalystApplication />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/analystApplicantJohnDoe/:id"
          element={
            <ProtectedRoutes>
              <AnalystApplicantJohnDoe />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/work"
          element={
            <ProtectedRoutes>
              <Work />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/uploadYourWorkHere"
          element={
            <ProtectedRoutes>
              <UploadYourWorkHere />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/areYouSureUpload"
          element={
            <ProtectedRoutes>
              <AreYouSureUpload />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/editProfile"
          element={
            <ProtectedRoutes>
              <EditProfile />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/accountSettings"
          element={
            <ProtectedRoutes>
              <AccountSettings />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/editSettings"
          element={
            <ProtectedRoutes>
              <EditSettings />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/wallet"
          element={
            <ProtectedRoutes>
              <Wallet />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/logout"
          element={
            <ProtectedRoutes>
              <Logout />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/video"
          element={
            <ProtectedRoutes>
              <Video />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/otpLogs/:id/:type"
          element={
            <ProtectedRoutes>
              <OtpLogs />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/logsVideo"
          element={
            <ProtectedRoutes>
              <LogsVideo />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/applicant/profile/:id"
          element={
            <ProtectedRoutes>
              <ApplicantProfile />
            </ProtectedRoutes>
          }
        />

        <Route
          path="/forgetPassword"
          element={
            <Redirect>
              <ForgetPassword />
            </Redirect>
          }
        />
        <Route
          path="/verifyYourEmail"
          element={
            <Redirect>
              <VerifyYourEmail />
            </Redirect>
          }
        />
        <Route
          path="/resetpassword"
          element={
            <Redirect>
              <Resetpassword />
            </Redirect>
          }
        />
        <Route path="/signUpScreen" element={<SignUpScreen />} />
      </Routes>
    </Router>
  );
}

export default App;
